export const environment = {
  production: false,
  // rinhoCmdApi: 'https://localhost:7277/api/Rinho/cmd/',
  rinhoCmdApi: 'https://comandos-api-qa-eqdmcuf6c7hndsd8.canadacentral-01.azurewebsites.net/api/Rinho/cmd/',
  apiUrl: 'https://qa-monitoreo-web-api.p-lock.net/api/'
  //apiUrl: 'https://monitoreo-web-api.p-lock.net/api/'
  //apiUrl: 'http://localhost:52776/api/'
};
